import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const heroImages = ['https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1600&q=80', 'https://cdn.magicpatterns.com/uploads/254gsweUo5hVSPSHyEupQB/HVAC.jpg', 'https://cdn.magicpatterns.com/uploads/2kN7V4j6E8Ra5mMH83Bzov/mfm.webp', 'https://cdn.magicpatterns.com/uploads/3XW5NpAMJMCuH3srhXLsXz/office.png'];
export function Hero() {
  const [currentImage, setCurrentImage] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage(prev => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  return <section className="relative h-screen min-h-[600px] flex items-center pt-20" data-id="element-235">
      <div className="absolute inset-0 z-0" data-id="element-236">
        <AnimatePresence mode="popLayout" data-id="element-237">
          <motion.img key={currentImage} src={heroImages[currentImage]} alt="Commercial HVAC installation" className="absolute inset-0 w-full h-full object-cover" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 1.2,
          ease: 'easeInOut'
        }} data-id="element-238" />
        </AnimatePresence>
        <div className="absolute inset-0 bg-primary-dark/60 mix-blend-multiply" data-id="element-239"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-primary-dark/80 via-transparent to-primary-dark/90" data-id="element-240"></div>
      </div>

      <div className="container mx-auto px-6 relative z-10 flex flex-col h-full justify-center" data-id="element-241">
        <div className="max-w-4xl" data-id="element-242">
          <motion.h1 initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="text-5xl md:text-7xl text-white font-serif leading-tight mb-4" data-id="element-243">
            Commercial AC installation & maintenance
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="text-xl md:text-2xl text-white/90 mb-10 font-light" data-id="element-244">
            Nationwide Daikin D1+ Premier Partners | Based in Coventry, West
            Midlands
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} data-id="element-245">
            <button className="group flex items-center gap-4 bg-accent hover:bg-accent/90 text-white px-6 py-3 rounded-full transition-all duration-300" data-id="element-246">
              <span className="font-medium" data-id="element-247">Get a free quote</span>
              <img src="https://cdn.magicpatterns.com/uploads/bPzFdwHywdHpFHfUSsV2QY/arrow-right-circle-white.svg" alt="" className="w-7 h-7 group-hover:translate-x-1 transition-transform" data-id="element-248" />
            </button>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.8
      }} className="absolute bottom-12 left-6 right-6 flex flex-col md:flex-row justify-between items-start md:items-end gap-6" data-id="element-249">
          <div className="text-white/80 text-sm max-w-[200px] leading-relaxed flex flex-col items-start gap-4" data-id="element-250">
            <span data-id="element-251">
              Commercial HVAC specialists
              <br data-id="element-252" />
              for over 16 years.
            </span>
            <img src="https://cdn.magicpatterns.com/uploads/gipzk5sVfmcGVM4txQ5ruk/arrow-down-banner.svg" alt="Scroll down" className="w-5 h-5 animate-bounce" data-id="element-253" />
          </div>

          <div className="flex items-center gap-4 text-white/90 text-sm font-medium tracking-wide" data-id="element-254">
            <span data-id="element-255">Daikin Premier</span>
            <span className="w-1.5 h-1.5 rounded-full bg-accent" data-id="element-256"></span>
            <span data-id="element-257">16yr Lifespans</span>
            <span className="w-1.5 h-1.5 rounded-full bg-accent" data-id="element-258"></span>
            <span data-id="element-259">Constructionline Gold</span>
          </div>
        </motion.div>
      </div>
    </section>;
}